<template>
  <Swiper
    :class="theme"
    class="arrow-menu"
    container-class="arrow-menu-container"
  >
    <ArrowMenuItem
      v-for="item in props.items"
      :key="item.id"
      :item="item"
      :theme="theme"
      @click-menu-item="$emit('click-menu-item', $event)"
    />

    <template #left-arrow>
      <ArrowMenuButton
        :theme="theme"
        aria-label="Пролистнуть меню влево"
        class="left-arrow"
        icon="arrow"
      />
    </template>

    <template #right-arrow>
      <ArrowMenuButton
        :theme="props.theme"
        aria-label="Пролистнуть меню вправо"
        class="right-arrow"
        icon="arrow"
      />
    </template>
  </Swiper>
</template>

<script lang="ts" setup>
  import type { PropType } from 'vue';
  import Swiper from '@devhacker/shared/components/Swiper.vue';
  import type { ILink, TTheme } from '~/components/ArrowMenu/ArrowMenu';
  import ArrowMenuItem from '~/components/ArrowMenu/ArrowMenuItem.vue';
  import ArrowMenuButton from '~/components/ArrowMenu/ArrowMenuButton.vue';

  defineOptions({
    name: 'ArrowMenu',
  });

  const props = defineProps({
    items: {
      type: Array as PropType<ILink[]>,
      required: true,
    },
    theme: {
      type: String as PropType<TTheme>,
      default: 'light',
    },
  });

  defineEmits(['click-menu-item']);
</script>

<style lang="scss" scoped>
  .arrow-menu {
    user-select: none;
    --swiper-scroll-padding: 8px;

    @include tablet {
      --swiper-scroll-padding: 16px;
    }

    &.light {
      --swiper-left-arrow-background: linear-gradient(90deg, #fff 5%, rgba(255, 255, 255, 0));
      --swiper-right-arrow-background: linear-gradient(270deg, #fff 5%, rgba(255, 255, 255, 0));

      @include tablet {
        --swiper-left-arrow-background: linear-gradient(90deg, #fff 55%, rgba(255, 255, 255, 0));
        --swiper-right-arrow-background: linear-gradient(270deg, #fff 55%, rgba(255, 255, 255, 0));
      }
    }

    &.dark {
      --swiper-left-arrow-background: linear-gradient(90deg, #000 5%, rgba(0, 0, 0, 0));
      --swiper-right-arrow-background: linear-gradient(270deg, #000 5%, rgba(0, 0, 0, 0));

      @include tablet {
        --swiper-left-arrow-background: linear-gradient(90deg, #000 55%, rgba(0, 0, 0, 0));
        --swiper-right-arrow-background: linear-gradient(270deg, #000 55%, rgba(0, 0, 0, 0));
      }
    }

    :deep(.arrow-menu-container) {
      display: flex;
      align-items: center;
      height: 48px;
      margin: 0 auto;
      padding: 0 8px;

      @include tablet {
        padding: 0 16px;
      }

      @include big-tablet {
        padding: 0 8px;
      }
    }
  }

  .left-arrow {
    transform: scaleX(-1);
  }
</style>
